import { REGISTRATION, TICKETING } from '../constants';
import { TERMINOLOGY } from '../constants/terminology';

/**
 * Returns the correct object to pull strings
 * @param  {Boolean} isRegEvent, true if the event has Registration terminology
 * @return {Object}
 */
export const getTerminology = (isRegEvent: boolean) =>
    isRegEvent ? TERMINOLOGY[REGISTRATION] : TERMINOLOGY[TICKETING];

export default getTerminology;
